import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCookieValue, isIOS, setCookie, useMessenger } from '../context/messengerContext';

const MAX_ID_KEY = 'max_id';
const IS_INVITED_USER_KEY = 'is_invited_user';

export function getIsInvitedUserFromStorage() {
    const ios = isIOS();
    if (ios) {
        return getCookieValue(IS_INVITED_USER_KEY);
    }
    return localStorage.getItem(IS_INVITED_USER_KEY);
}

export function saveIsInvitedUserToStorage() {
    const ios = isIOS();
        
    // На iOS ВСЕГДА сохраняем в cookies (они копируются при установке PWA)
    // На других платформах сохраняем в localStorage
    if (ios) {
        setCookie(IS_INVITED_USER_KEY, 'true');
        console.log(`📱 iOS detected: saved max_id to cookie (will be copied on PWA install)`);
    } else {
        localStorage.setItem(IS_INVITED_USER_KEY, 'true');
        console.log(`💾 Non-iOS: saved max_id to localStorage`);
    }
}

/**
 * Парсит start_param из Telegram/Max deep linking.
 * start_param — JSON, закодированный в base64.
 */
function parseStartParam(raw) {
    if (!raw) return null;

    try {
        const decoded = atob(raw);
        return JSON.parse(decoded);
    } catch {
        return null;
    }
}

/**
 * Проверяет наличие max_id в URL или localStorage для MAX платформы
 */
function hasMaxId() {
    const urlParams = new URLSearchParams(window.location.search);
    const maxIdFromUrl = urlParams.get(MAX_ID_KEY);
    const maxIdFromStorage = localStorage.getItem(MAX_ID_KEY);
    return Boolean(maxIdFromUrl || maxIdFromStorage);
}

export function useAuthRedirect() {
    const navigate = useNavigate();
    const { initDataUnsafe, platform } = useMessenger();

    useEffect(() => {
        const startParam = initDataUnsafe?.start_param;
        const payload = parseStartParam(startParam);

        // Telegram: пользователь уже авторизован через initData
        if (platform === 'telegram') {
            navigate('/menu', { replace: true });
            return;
        }

        // Для MAX проверяем наличие max_id в URL или localStorage
        if (platform === 'max') {
            if (hasMaxId()) {
                navigate('/menu', { replace: true });
                return;
            }
        }

        if (!payload || !payload.action) {
            navigate('/menu', { replace: true });
            return;
        }

        const { action, contract_number, cdek_id } = payload;

        switch (action) {
            case 'need_auth':
                navigate('/auth', {
                    replace: true,
                    state: { first: '1' },
                });
                break;

            case 'need_auth_contact':
                navigate('/auth_contact', {
                    replace: true,
                    state: { contract_number, first: '1' },
                });
                break;

            case 'courier_error': {
                const courierParams = new URLSearchParams();
                if (contract_number)
                    courierParams.set('contract_number', contract_number);
                if (cdek_id) courierParams.set('cdek_id', cdek_id);
                const courierQuery = courierParams.toString();
                navigate(`/courier${courierQuery ? `?${courierQuery}` : ''}`, {
                    replace: true,
                });
                break;
            }

            case 'open_chat': {
                const chatParams = new URLSearchParams();
                if (contract_number)
                    chatParams.set('contract_number', contract_number);
                const chatQuery = chatParams.toString();
                navigate(`/enter_chat${chatQuery ? `?${chatQuery}` : ''}`, {
                    replace: true,
                });
                break;
            }

            case 'auth':
            default:
                navigate('/menu', { replace: true });
                break;
        }
    }, [initDataUnsafe, platform, navigate]);
}
